import Widget, { IWidgetConsumer } from 'app/components/common/Widget';
import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import React, { useCallback, useEffect, useMemo } from 'react';
import { TableModel, TableRow } from 'app/components/table/table.model';
import { Table } from 'app/components/table/table';
import { NachfolgePlanungVm } from 'app/stores/ui/nachfolgeplanung.ui.store';
import { WidgetNavigate } from 'app/components/common/WidgetNavigate';
import { useHistoryWithQuery } from 'app/hooks/useHistoryWithQuery';
import routes from 'routes';
import { Icon } from '../common/Icon';
import { formatNum } from 'app/utils';

export const BestandsnachfolgePlanungWidget = observer((props: IWidgetConsumer) => {
	const { nachfolgeplanungUiStore } = useStore();
	const history = useHistoryWithQuery();

	const tm = useMemo(() => {
		const tm = new TableModel<NachfolgePlanungVm, number>();
		const cols = [
			{
				label: 'Inhaber',
				path: 'inhaberName',
			},
			{
				label: 'Alter',
				path: 'inhaberAge',
			},
			{
				label: 'Kunden',
				path: 'anzKunden18',
				format: formatNum,
			},
			{
				label: 'Gesamtbew. VJ',
				path: 'gesamtbewertungVJ',
				format: formatNum,
			},
			{
				label: 'Fokusthema',
				path: 'hasFocusThema',
				render: (row: TableRow<NachfolgePlanungVm>) => {
					return (
						<>
							{row.data.focusThemen.length > 0 && (
								<span className="tag is-blue is-small">
									<Icon iconClass="check" />
								</span>
							)}
						</>
					);
				},
			},
		];

		tm.onRowClick = (row: TableRow<NachfolgePlanungVm>) => {
			const p = routes.BERICHTE.getPath('bestand', 'bestandsnachfolge', 'nachfolgeplanung', row.data.agt.agtId.toString());
			history.pushWithQuery(p);
		};

		tm.setCols(cols);
		tm.sortBy = 'inhaberAge';
		tm.sortAsc = false; // descending order (oldest first)
		tm.idProperty = 'agt.agtId';
		tm.idType = 'number';
		return tm;
	}, [history]);

	const loadData = useCallback(() => {
		nachfolgeplanungUiStore.load().then(() => {
			const items = nachfolgeplanungUiStore.items;
			// Filter for agencies with inhaber older than 60
			const filtered = items.filter((item: NachfolgePlanungVm) => item.inhaberAge >= 60 && item.inhaberAge < 100);
			tm.setRowData(filtered);
		});
	}, [tm, nachfolgeplanungUiStore]);

	useEffect(() => {
		loadData();
	}, [loadData]);

	return (
		<Widget
			title="Bestandsnachfolgeplanung"
			modifier="is-paddingless"
			widgetId={props.widgetKey}
			disableCollapse={props.disableCollapse!!}
			action={<WidgetNavigate text="Zum Bericht" path="/berichte/bestand/bestandsnachfolge/nachfolgeplanung" />}
		>
			<Table modifier="is-compact" tm={tm}></Table>
		</Widget>
	);
});
